import { ContactCornSchema } from '@eigtech/contacts-types';
import { JobDetailsAppointmentSchema, JobIdSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
export const JobAppointmentSchema = JobDetailsAppointmentSchema.merge(z.object({ jobId: JobIdSchema }));
export const GetAppointmentsApiSchema = {
    params: z.object({
        contactId: ContactCornSchema,
        assignmentType: z.enum(['subcontractor', 'fieldTechnician']),
    }),
    query: z.object({ filter: z.string().optional() }),
    response: z.object({
        appointments: JobAppointmentSchema.array(),
    }),
};
export const GetAppointmentsRequestSchema = GetAppointmentsApiSchema.query.merge(GetAppointmentsApiSchema.params);
export const GetAppointmentsResponseSchema = GetAppointmentsApiSchema.response;
